import React, { useState } from 'react';
import css from './CtaBannerSection.module.css';
import bannerBg from '../../../../assets/CTA-Section-image.png';
import { apiBaseUrl } from '../../../../util/api';
import { LEADFLOW_TALK_TO_SALES_CALENDLY_URL } from '../../../../util/enums';
import FreeviewSignupModal from '../FreeviewSignupModal/FreeviewSignupModal';

const LockIcon = () => (
  <svg width="12" height="14" viewBox="0 0 24 24" fill="white" style={{ marginRight: 5, verticalAlign: 'middle' }}>
    <path d="M18 10h-1V7A5 5 0 0 0 7 7v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm-6 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm3-7H9V7a3 3 0 0 1 6 0v3z"/>
  </svg>
);

const CtaBannerSection = ({ currentUser }) => {
  const [activeTab, setActiveTab] = useState('freeview');
  const [showModal, setShowModal] = useState(false);
  const [isGeneratingToken, setIsGeneratingToken] = useState(false);

  const isAuthenticated = Boolean(currentUser?.id?.uuid);
  const isLeadflowAccessProvided =
    currentUser?.attributes?.profile?.publicData?.isLeadflowAccessProvided;

  const handleFreeviewClick = async () => {
    if (isAuthenticated && isLeadflowAccessProvided) {
      try {
        setIsGeneratingToken(true);
        const apiUrl = `${apiBaseUrl()}/api/leadflow/generate-sso-token`;
        const response = await fetch(apiUrl, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({}),
        });
        const data = await response.json();
        if (data.success && data.data.redirectUrl && typeof window !== 'undefined') {
          window.open(data.data.redirectUrl, '_blank');
        }
      } catch (err) {
        console.error('SSO error:', err);
      } finally {
        setIsGeneratingToken(false);
      }
    } else {
      setShowModal(true);
    }
  };

  const handleTalkToSales = () => {
    if (typeof window !== 'undefined') {
      window.open(LEADFLOW_TALK_TO_SALES_CALENDLY_URL, '_blank');
    }
  };

  return (
    <section className={css.section}>
      <img src={bannerBg} alt="" className={css.bgImage} />
      <div className={css.inner}>
        <h2 className={css.heading}>What one extra project per month looks like</h2>
        <p className={css.subheading}>No commitment - just real data in your region</p>

        {isAuthenticated && isLeadflowAccessProvided ? (
          <>
            <button
              className={css.ctaButton}
              onClick={handleFreeviewClick}
              disabled={isGeneratingToken}
            >
              {isGeneratingToken ? 'Connecting…' : 'Access live projects →'}
            </button>
            <p className={css.noCreditCard}>
              <LockIcon />
              No credit card required, instant access
            </p>
          </>
        ) : (
          <>
            <div className={css.sliderToggle}>
              <button
                className={`${css.sliderOption} ${activeTab === 'freeview' ? css.sliderActive : ''}`}
                onClick={() => setActiveTab('freeview')}
              >
                Freeview of live projects
              </button>
              <button
                className={`${css.sliderOption} ${activeTab === 'sales' ? css.sliderActive : ''}`}
                onClick={() => setActiveTab('sales')}
              >
                Talk to sales
              </button>
            </div>

            {activeTab === 'freeview' ? (
              <>
                <button className={css.ctaButton} onClick={handleFreeviewClick}>
                  View live projects free →
                </button>
                <p className={css.noCreditCard}>
                  <LockIcon />
                  No credit card required, instant access
                </p>
              </>
            ) : (
              <>
                <button className={css.ctaButton} onClick={handleTalkToSales}>
                  Book a free call →
                </button>
                <p className={css.noCreditCard}>
                  Full access · Dedicated support · Regional targeting
                </p>
              </>
            )}
          </>
        )}
      </div>

      {showModal && <FreeviewSignupModal onClose={() => setShowModal(false)} />}
    </section>
  );
};

export default CtaBannerSection;
